import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import NetworkStatus from "./pages/common/NetworkStatus";
import AdminRoutes from "./routes/AdminRoutes";
import MerchantRoutes from "./routes/MerchantRoutes";
import FundraiserRoutes from "./routes/FundraiserRoutes";
import UserRoutes from "./routes/UserRoutes";
import CommonRoutes from "./routes/CommonRoutes";
import SessionTimeoutGuard from "./components/common/SessionTimeoutGuard";
import WebNotifications from "./components/common/WebNotifications";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NetworkStatus isOnline={isOnline} setIsOnline={setIsOnline} />
        <SessionTimeoutGuard />
        <WebNotifications />

        {isOnline && (
          <Routes>
            <Route path="/*" element={<CommonRoutes />} />
            <Route path="/admin/*" element={<AdminRoutes />} />
            <Route path="/merchant/*" element={<MerchantRoutes />} />
            <Route path="/fundraiser/*" element={<FundraiserRoutes />} />
            <Route path="/user/*" element={<UserRoutes />} />
          </Routes>
        )}
      </PersistGate>
    </Provider>
  );
}

export default App;
